<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit="handleOnSubmit(showAddForm)"
    onSubmit="return false;"
  >
    <v-row dense class="ml-5 mr-2" v-if="showAddForm === 'invite'">
      <v-col cols="7">
        <v-text-field
          color="primary"
          :rules="emailRules"
          v-model="email"
          :label="
            $t('components.miscellaneous.rangeUserForm.enterEMailAddress')
          "
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="role"
          :items="roleOptions"
          color="primary"
          :label="$t('components.miscellaneous.rangeUserForm.selectRole')"
          item-text="name"
          item-value="uuid"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-btn
          class="mt-4 float-right"
          color="primary"
          text
          @click="inviteUser()"
          ><v-icon class="mr-2">mdi-account-plus</v-icon
          >{{ $t("components.miscellaneous.rangeUserForm.add") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense class="ml-5 mr-2" v-if="showAddForm === 'range'">
      <v-col cols="10">
        <v-text-field
          color="primary"
          v-model="range"
          :label="$t('components.miscellaneous.rangeUserForm.rangeName')"
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-btn
          class="mt-4 float-right"
          color="primary"
          text
          @click="setRange(groupUuid)"
        >
          <v-icon class="mr-2">mdi-plus-circle</v-icon
          >{{ $t("components.miscellaneous.rangeUserForm.add") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import api from "@/utils/api.js";
import snackbar from "@/utils/snackbar.js";
import { USER_CRM_REQUEST } from "@/store/actions/user";

export default {
  props: {
    showAddUserRangeForm: {
      type: String,
      default: "",
    },
    roleOptions: {
      type: Array,
      default: Array,
    },
    groupUuid: {
      type: String,
      default: String,
    },
  },
  data() {
    return {
      valid: false,
      email: "",
      range: "",
      role: null,
      emailRules: [],
    };
  },
  computed: {
    showAddForm() {
      return this.showAddUserRangeForm;
    },
  },

  created() {
    this.setInitalData();
  },
  methods: {
    setInitalData() {
      this.emailRules = [
        (v) =>
          /[^@]+@[^.]+\..*/.test(v) ||
          this.$t("components.miscellaneous.rangeUserForm.eMailMustBeValid"),
      ];
    },
    handleOnSubmit(event) {
      if (event === "") return;

      event === "range" ? this.setRange(this.groupUuid) : this.inviteUser();
    },
    inviteUser(user, role) {
      let username = typeof user !== "undefined" ? user.username : this.email;
      let roleUuid = typeof role !== "undefined" ? role.uuid : this.role;

      if (typeof user !== "undefined" && typeof role !== "undefined") {
        this.clearInviteForm();
        this.setUser(roleUuid, username);
      } else if (this.$refs.form.validate()) {
        this.setUser(roleUuid, username);
      } else {
        snackbar.error();
      }
    },

    setUser(roleUuid, username) {
      this.loading = true;
      this.$emit("update:loading", true);
      api
        .inviteRoleUser(this.groupUuid, roleUuid, {
          email: username,
          replace_existing: true,
        })
        .then((resp) => {
          api.getGroup(this.groupUuid).then((resp) => {
            // this.group.roles = resp.data.roles;
            this.$store.dispatch(USER_CRM_REQUEST).then((resp) => {
              this.loading = false;
              this.$emit("update:loading", false);
            });
            this.$emit("update:roles", resp.data.roles);
            snackbar.success(
              this.$t("utils.snackbar.success.userSuccessfullyInvited"),
              false
            );
            this.clearInviteForm();
          });
        })
        .catch((error) => {
          if (
            typeof error.response.data.error_type !== "undefined" &&
            error.response.data.error_type === "MEMBER_OF_OTHER_SUPERGROUPS"
          ) {
            snackbar.error(error.response.data.error);
          } else {
            snackbar.error();
          }
          this.loading = false;
          this.$emit("update:loading", false);
        });
    },

    setRange(groupUuid) {
      this.loading = true;
      this.$emit("update:loading", true);
      api.createGroup(groupUuid, { name: this.range }).then((resp) => {
        snackbar.success(
          this.$t("utils.snackbar.success.rangeSuccessfullyCreated"),
          false
        );
        this.$emit("update:ranges", { uuid: groupUuid, data: resp.data });
        this.loading = false;
        this.range = "";
        this.$emit("update:loading", false);
      });
    },

    clearInviteForm() {
      this.email = "";
      this.role = null;
      if (this.showAddForm) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>

<style></style>
